export class ProfileRoutingNames {
    public static readonly NAME_BASE = '';
    public static readonly NAME_PROFILE = 'my-profile';

    public static readonly ROUTE_BASE = `/${ProfileRoutingNames.NAME_BASE}`;
    public static readonly ROUTE_PROFILE = `/${ProfileRoutingNames.NAME_PROFILE}`;
}
